export const prizePageIndexMetadata = {
  metaTitle: 'Win Prizes Online | Trips, Experiences and More | DAYMADE',
  metaDescription:
    'Win prizes online with DAYMADE. From gift cards and gadgets to the holidays of a lifetime. Find out how you could be going on your next adventure here.',
} as const;
